import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';

import rootReducer from './reducers/';
import { loadStateFromLocalStorage } from './actions/defaultActions';
import websocketMiddleware from './middleware/websocketMiddleware';

const store = createStore(
  rootReducer,
  loadStateFromLocalStorage(),
  compose(
    applyMiddleware(...[thunk, websocketMiddleware])
    //, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

export default store;
